
import DetailComponentBase from "@/app/dynamic-components/details/details-components/detail-component.base";
import { DynamicDetailEntry } from "@/app/dynamic-components/details/dynamic-detail.model";
import { DetailContext } from "@/app/contexts/detail.context";
import { Component } from "vue-property-decorator";

export type TextMetaData = {
  showEmail: boolean;
  showTelephone: boolean
  selector: string;
};

@Component({})
export default class DetailComponentContactdetails extends DetailComponentBase<TextMetaData> {
  value: any | null = null;

  postEntityChanged(newValue: DynamicDetailEntry) {
    if (this.detailContext && this.entry) {
      this.value = this.detailContext.resolveFieldValue(this.metadata.selector);
    }
  }

  protected postDetailContextChanged(newValue: DetailContext) {
    if (this.entry && this.detailContext) {
      this.value = this.detailContext.resolveFieldValue(this.metadata.selector);
    }
  }

  displayValue(): string{
    if (this.value === null || this.value === undefined || typeof this.value !== 'object') return "-";

    return (this.value?.firstName || '') + ' '+ (this.value?.lastName || '');
  }

  displayValueEmail(): string | null{
    if (this.value === null || this.value === undefined || typeof this.value !== 'object') return null;

    if(this.metadata.showEmail){
      return this.value?.email || ''
    }
    return null;
  }

  displayValuePhone(): string | null{
    if (this.value === null || this.value === undefined || typeof this.value !== 'object') return null;

    if(this.metadata.showTelephone){
      return this.value?.telephone || ''
    }
    return null;
  }
}
